

























































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { Auth } from 'aws-amplify';

@Component({
  components: {
    CommonButton,
  },
})
export default class ConfirmPasswordSendCode extends Vue {
  private accountName: string = '';

  private async onSendCode() {
    try {
      if (this.accountName === '') {
        alert('アカウント名は必須です。');
        return;
      }
      await Auth.forgotPassword(this.accountName);
      alert('確認コードが送信されました。');
      this.$router.push({ name: 'confirmPassword' });
    } catch (error) {
      alert('予期しないエラーが発生しました。');
    }
  }
}
